import { TYPES_BORDEREAU_ANNULATION } from '../../../constants/mouvements/typeBordereau';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BordereauRejeterCollectiviteAction from './BordereauRejeterCollectiviteAction';

/**
 * Annulation d'un bordereau numéroté : même traitement que le rejet (BordereauRejeterCollectiviteAction), mais
 * l'API crée un bordereau d'annulation (02) au lieu d'un bordereau de rejet ; le bordereau d'origine passe aussi à
 * l'état rejeté.
 */
class BordereauAnnulerAction extends BordereauRejeterCollectiviteAction {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Annuler le bordereau';
		this.type = BordereauActionType.ANNULER_REDUIRE;
		this.isShown = (bordereau) =>
			!TYPES_BORDEREAU_ANNULATION.includes(bordereau.typePes);
	}

	execute = (
		_bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.MODAL,
		extraProps: {
			isSuperUser: this.isSuperUser,
			bordereauRejeterCollectiviteModal: {
				visible: true,
				estAnnulation: true,
			},
		},
	});
}

export default BordereauAnnulerAction;
